// Service User Profile - Utilise Supabase directement
import { 
  getUserProfile as getProfile,
  updateUserProfile as updateProfile,
  updateUserRole as updateRole,
  createUserProfile as createProfile,
  deleteUserProfile as deleteProfile
} from './supabaseService';

class UserProfileService {
  /**
   * Récupère le profil complet d'un utilisateur
   */
  async getUserProfile(firebaseUserId) {
    try {
      const response = await getProfile(firebaseUserId);
      return response;
    } catch (error) {
      console.error('Erreur récupération profil:', error);
      throw error;
    }
  }

  /**
   * Met à jour le profil utilisateur
   */
  async updateUserProfile(firebaseUserId, profileData) {
    try {
      const response = await updateProfile(firebaseUserId, profileData);
      return response;
    } catch (error) {
      console.error('Erreur mise à jour profil:', error);
      throw error;
    }
  }

  /**
   * Met à jour le rôle de l'utilisateur
   */
  async updateUserRole(firebaseUserId, newRole) {
    try {
      const response = await updateRole(firebaseUserId, newRole);
      return response;
    } catch (error) {
      console.error('Erreur mise à jour rôle:', error);
      throw error;
    }
  }

  /**
   * Supprime complètement le profil utilisateur
   */
  async deleteUserProfile(firebaseUserId) {
    try {
      const response = await deleteProfile(firebaseUserId);
      return response;
    } catch (error) {
      console.error('Erreur suppression profil:', error);
      throw error;
    }
  }

  /**
   * Crée un profil utilisateur s'il n'existe pas
   */
  async createUserProfileIfNotExists(firebaseUserId, userData) {
    try {
      const response = await createProfile(firebaseUserId, {
        email: userData.email || '',
        username: userData.username || '',
        role: userData.role || 'viewer'
      });
      return response;
    } catch (error) {
      console.error('Erreur création profil:', error);
      throw error;
    }
  }
}

export default new UserProfileService();
